import { render, staticRenderFns } from "./PTBrowserModal.vue?vue&type=template&id=41ed3d46&"
import script from "./PTBrowserModal.vue?vue&type=script&lang=js&"
export * from "./PTBrowserModal.vue?vue&type=script&lang=js&"
import style0 from "./PTBrowserModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports